module.exports = __webpack_public_path__ + "static/media/sprites_2x.d85f681b.png";